(() => {
 const initialize = () => {
  document.querySelectorAll('[data-pp-learning]').forEach(root => {
  if(root.dataset.initialized) return;
  root.dataset.initialized='true';
  root.classList.add('learn-js');
  const tabs = [...root.querySelectorAll('.care-tabs [role="tab"]')];
  const selectTab = (tab, focus = false) => {
    tabs.forEach(item => {
      const active = item === tab;
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
      root.querySelector('#'+item.getAttribute('aria-controls')).hidden = !active;
    });
    if (focus) tab.focus();
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => selectTab(tab));
    tab.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next !== undefined) { event.preventDefault(); selectTab(tabs[next], true); }
    });
  });
  const comparison = root.querySelector('#compare-option');
  if (comparison) {
    const update = () => root.querySelectorAll('[data-option]').forEach(cell => cell.classList.toggle('mobile-selected', cell.dataset.option === comparison.value));
    comparison.addEventListener('change', update);
    update();
  }
  });
 };
 initialize();
 document.addEventListener("shopify:section:load", initialize);
})();
